export default {
    formatPrivacyPolicyTitle: (date) => {
        const offset = date.getTimezoneOffset();
        date = new Date(date.getTime() - (offset * 60 * 1000));
        return `Privacy Policy Archive ${date.toISOString().split('T')[0]}`;
    }
};